import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { init } from 'src/util/mdello-instance';
import InnerContent from '../component/InnerContent';
import Loader from '../component/Loader/Loader';

const PrivateRoute = ({ children, ...rest }) => {
  const login = useSelector(({ login }) => login);

  const { isInitialised } = login;
  const isAuthenticated = login.user !== null;

  if (!isInitialised) {
    return <Loader />;
  }

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (isAuthenticated) {
          init();
        }
        return isAuthenticated ? (
          // eslint-disable-next-line react/no-children-prop
          <InnerContent children={children} location={location} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location }
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
